import api from './api';

export type ViewerLevel = 'records' | 'details' | 'options';

export interface ViewerField {
  slug: string;
  label: string;
  dataType: string;
  unit: string | null;
  isMasterMetric: boolean;
}

export interface ViewerMeta {
  fields: Record<ViewerLevel, ViewerField[]>;
  counts: Record<ViewerLevel, number>;
  defaultColumns: string[];
}

export interface ViewerRow {
  id: string;
  timestamp: string | null;
  values: Record<string, unknown>;
  childCount: number | null;
}

export interface ViewerPage {
  rows: ViewerRow[];
  total: number;
}

export interface ViewerListParams {
  limit: number;
  offset: number;
  sort?: string;
  dir?: 'asc' | 'desc';
  days?: number;
  parentId?: string;
}

export const viewerApi = {
  getMeta: async (accountId: string): Promise<ViewerMeta> => {
    const { data } = await api.get(`/api/viewer/${accountId}/meta`);
    return data.data as ViewerMeta;
  },
  list: async (accountId: string, level: ViewerLevel, params: ViewerListParams): Promise<ViewerPage> => {
    const { data } = await api.get(`/api/viewer/${accountId}/${level}`, { params });
    return data.data as ViewerPage;
  },
};
